import React, { useMemo, useState } from "react";
import "../styles/PlanesContenidoAds.scss";

const WHATS_NUMBER = "5215588093678";

const buildWaLink = (text) =>
  `https://wa.me/${WHATS_NUMBER}?text=${encodeURIComponent(text)}`;

const PlanesContenidoAds = () => {
  const [mode, setMode] = useState("campanas"); // "campanas" | "contenido"

  const planDesdeCero = useMemo(
    () => ({
      color: "green",
      badge: "🟢",
      name: "Plan Activación (Desde Cero)",
      price: "$799 / mes",
      short:
        "Ideal si aún no tienes presencia y quieres empezar a generar mensajes desde el primer mes.",
      bullets: [
        "8 publicaciones estratégicas",
        "1 reel con voz IA",
        "1 campaña de mensajes (7 días)",
        "Apertura y configuración de página en Facebook",
        "Monitoreo durante la campaña",
      ],
      note: "La pauta publicitaria es adicional (la paga el cliente).",
      waText:
        "Hola, quiero contratar el Plan Activación (Desde Cero) de $800/mes. ¿Qué necesito para iniciar?",
    }),
    []
  );

  const soloCampanas = useMemo(
    () => [
      {
        color: "green",
        badge: "🟢",
        name: "Plan Impulso",
        price: "$799 (7 días)",
        short: "Campaña puntual para generar mensajes sin compromiso mensual.",
        bullets: [
          "Campaña objetivo: mensajes (7 días)",
          "Segmentación + estructura del anuncio",
          "Monitoreo durante el periodo activo",
          "Pauta sugerida incluida: $500 MXN",
        ],
        note: "Ideal para activaciones rápidas.",
        waText:
          "Hola, quiero información del Plan Impulso ($800 por 7 días). ¿Cómo lo iniciamos?",
      },
      {
        color: "blue",
        badge: "🔵",
        name: "Plan Flexible",
        price: "Desde $299 (7 días)",
        short: "Si ya tienes redes y quieres campañas por ciclos, según tu presupuesto.",
        bullets: [
          "Segmentación y configuración",
          "Monitoreo durante el ciclo",
          "Análisis básico al finalizar",
          "Pauta adicional definida por el cliente",
        ],
        note: "Si contratas 2+ ciclos al mes, el costo por campaña puede ajustarse.",
        waText:
          "Hola, quiero información del Plan Flexible (desde $300 por 7 días). Quiero campañas por ciclos.",
      },
    ],
    []
  );

  const contenidoYCampanas = useMemo(
    () => [
      {
        color: "green",
        badge: "🟢",
        name: "Plan Activación",
        price: "$799 / mes",
        short:
          "Sistema básico para empezar a generar mensajes y movimiento real en tu negocio.",
        bullets: [
          "8 publicaciones estratégicas",
          "1 reel con voz IA",
          "1 campaña de mensajes (7 días)",
          "Monitoreo durante la campaña",
        ],
        note: "La pauta publicitaria es adicional (la paga el cliente).",
        waText:
          "Hola, quiero contratar el Plan Activación ($800/mes) de Contenido + Campañas. ¿Qué sigue?",
      },
      {
        color: "blue",
        badge: "🔵",
        name: "Plan Crecimiento",
        price: "$1,199 / mes",
        short:
          "Para generar un flujo más constante de mensajes y prospectos durante el mes.",
        bullets: [
          "12 publicaciones estratégicas",
          "2 reels con voz IA",
          "2 campañas de mensajes (7 días c/u)",
          "Distribución estratégica en el mes",
        ],
        note: "La pauta publicitaria es adicional (la paga el cliente).",
        waText:
          "Hola, me interesa el Plan Crecimiento ($1,200/mes) de Contenido + Campañas. Quiero más prospectos.",
        featured: true,
        featuredLabel: "Más vendido",
      },
      {
        color: "red",
        badge: "🔴",
        name: "Plan Bot",
        price: "$1,799 / mes",
        short:
          "Sistema integral: campañas todo el mes + bot en Messenger para filtrar prospectos.",
        bullets: [
          "Publicación diaria (L-S)",
          "4 reels (1 por semana)",
          "Campañas activas 4 semanas (ciclos de 7 días)",
          "Bot básico en Messenger (captura datos)",
        ],
        note:
          "La pauta publicitaria es adicional. Bot incluido en configuración inicial.",
        waText:
          "Hola, quiero el Plan Bot ($1,800/mes). Me interesa el bot en Messenger y campañas todo el mes.",
      },
    ],
    []
  );

  const plans = mode === "campanas" ? soloCampanas : contenidoYCampanas;

  return (
    <section className="ovit-plans" id="planes">
      <div className="ovit-plans__container">
        <header className="ovit-plans__header">
          <h2 className="ovit-plans__title">
            Planes para <span>tu nivel actual</span>
          </h2>
          <p className="ovit-plans__subtitle">
            Elige la opción correcta: si vas empezando desde cero o si ya tienes redes y quieres acelerar resultados.
          </p>
        </header>

        {/* SECTION 1: Desde cero */}
        <div className="ovit-plans__section">
          <div className="ovit-plans__sectionHead">
            <div className="ovit-plans__tag">Empiezo desde cero</div>
            <div className="ovit-plans__sectionTitle">
              ¿No tienes redes? / ¿No tienes página de negocio?
            </div>
            <div className="ovit-plans__sectionDesc">
              Te abrimos y configuramos tu página en Facebook y arrancamos con contenido + campaña para generar mensajes.
            </div>
          </div>

          <div className="ovit-plans__grid ovit-plans__grid--one">
            <PlanCard plan={planDesdeCero} />
          </div>
        </div>

        {/* SECTION 2: Ya tienes redes */}
        <div className="ovit-plans__section">
          <div className="ovit-plans__sectionHead">
            <div className="ovit-plans__tag">Ya tengo redes</div>
            <div className="ovit-plans__sectionTitle">Elige tu modalidad</div>
            <div className="ovit-plans__sectionDesc">
              Puedes contratar solo campañas por ciclos o un sistema completo de contenido + campañas.
            </div>

            <div className="ovit-plans__toggle" role="tablist" aria-label="Selector de modalidad">
              <button
                type="button"
                className={`ovit-plans__toggleBtn ${mode === "campanas" ? "is-active" : ""}`}
                onClick={() => setMode("campanas")}
                role="tab"
                aria-selected={mode === "campanas"}
              >
                Solo campañas
              </button>
              <button
                type="button"
                className={`ovit-plans__toggleBtn ${mode === "contenido" ? "is-active" : ""}`}
                onClick={() => setMode("contenido")}
                role="tab"
                aria-selected={mode === "contenido"}
              >
                Contenido + campañas
              </button>
            </div>
          </div>

          <div className="ovit-plans__grid">
            {plans.map((p) => (
              <PlanCard key={p.name} plan={p} />
            ))}
          </div>

          <div className="ovit-plans__note">
            *La inversión en pauta publicitaria es adicional, salvo donde se indique incluido.
          </div>
        </div>
      </div>
    </section>
  );
};

function PlanCard({ plan }) {
  const waLink = buildWaLink(plan.waText);

  return (
    <article className={`ovit-planCard ovit-planCard--${plan.color} ${plan.featured ? "is-featured" : ""}`}>
      <div className="ovit-planCard__top">
        <div className="ovit-planCard__name">
          <span className="ovit-planCard__badge">{plan.badge}</span>
          <span>{plan.name}</span>
        </div>

        {plan.featured && (
          <div className="ovit-planCard__hot">
            {plan.featuredLabel || "Destacado"}
          </div>
        )}
      </div>

      <div className="ovit-planCard__price">{plan.price}</div>
      <p className="ovit-planCard__short">{plan.short}</p>

      <ul className="ovit-planCard__list">
        {plan.bullets.map((b) => (
          <li key={b}>
            <span className="ovit-planCard__check">✓</span>
            <span>{b}</span>
          </li>
        ))}
      </ul>

      <div className="ovit-planCard__foot">
        <div className="ovit-planCard__note">{plan.note}</div>

        <div className="ovit-planCard__actions">
          <a className="ovit-planCard__btn" href={waLink} target="_blank" rel="noopener noreferrer">
            Quiero este plan
          </a>
          <a className="ovit-planCard__link" href="#faq">
            Dudas → FAQ
          </a>
        </div>
      </div>
    </article>
  );
}

export default PlanesContenidoAds;